(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zayn-brands-futuristic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zayn-brand-portal')) {
  customElements.define('zayn-brand-portal', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.classList.add('zbf--enhanced');

      this.observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) this.classList.add('is-inview');
      }, { threshold: .12 });
      this.observer.observe(this);

      this.querySelectorAll('.zbf__card').forEach(card => {
        card.addEventListener('pointermove', event => {
          if (event.pointerType !== 'mouse' || this.reduced.matches) return;
          const rect = card.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          card.style.transform = `perspective(900px) rotateX(${(-y * 4.5).toFixed(2)}deg) rotateY(${(x * 5.5).toFixed(2)}deg) translateY(-6px)`;
        }, { signal });
        card.addEventListener('pointerleave', () => { card.style.transform = ''; }, { signal });
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zayn-discovery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zayn-discovery')){
  customElements.define('zayn-discovery',class extends HTMLElement{
    connectedCallback(){
      this.items=Array.from(this.querySelectorAll('.zayn-discovery__item'));
      this.timer=null;
      this.abort=new AbortController();
      const opts={signal:this.abort.signal};
      try{if(sessionStorage.getItem('zayn-discovery-seen')==='1')return;}catch(e){}
      if(!this.items.length)return;

      this.position=()=>{
        if(window.innerWidth>749)return;
        const header=document.querySelector('.section-header');
        const bottom=header?header.getBoundingClientRect().bottom:0;
        this.style.setProperty('--zayn-discovery-top',Math.max(12,bottom+10)+'px');
      };

      this.querySelector('button').addEventListener('click',()=>this.dismiss(),opts);
      window.addEventListener('resize',this.position,opts);
      window.addEventListener('scroll',this.position,{...opts,passive:true});
      this.position();

      this.timer=setTimeout(()=>this.showOnce(),3200);
    }
    showOnce(){
      if(document.hidden){this.timer=setTimeout(()=>this.showOnce(),1800);return;}
      const item=this.items[0];
      this.items.forEach(el=>el.hidden=true);
      item.hidden=false;
      this.hidden=false;
      this.position();
      try{sessionStorage.setItem('zayn-discovery-seen','1');}catch(e){}
      this.timer=setTimeout(()=>{this.hidden=true;},6500);
    }
    dismiss(){
      clearTimeout(this.timer);
      this.hidden=true;
      try{sessionStorage.setItem('zayn-discovery-seen','1');}catch(e){}
    }
    disconnectedCallback(){clearTimeout(this.timer);if(this.abort)this.abort.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zayn-six-essences"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zayn-essences')) {
  customElements.define('zayn-essences', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.index = 0;
      this.bottles = [...this.querySelectorAll('[data-bottle]')];
      this.stories = [...this.querySelectorAll('[data-story]')];
      this.picks = [...this.querySelectorAll('[data-pick]')];
      this.play = this.querySelector('[data-play]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.stage = this.querySelector('.ze__stage');
      this.touchStart = null;
      this.classList.add('ze--enhanced');
      this.running = this.dataset.autoplay === 'true' && !this.reduced.matches;
      this.visible = true;
      this.hovered = false;
      this.focused = false;
      this.picks.forEach((button, i) => button.addEventListener('click', () => this.select(i, true), {signal}));
      this.querySelector('[data-prev]').addEventListener('click', () => this.select(this.index - 1, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.select(this.index + 1, true), {signal});
      this.play.addEventListener('click', () => { this.running = !this.running; this.focused = false; this.hovered = false; this.updatePlay(); this.schedule(); }, {signal});
      if (this.stage) {
        this.stage.addEventListener('pointermove', event => {
          if (event.pointerType !== 'mouse' || this.reduced.matches) return;
          const rect = this.stage.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          this.style.setProperty('--ze-tilt-y', `${(x * 7).toFixed(2)}deg`);
          this.style.setProperty('--ze-tilt-x', `${(-y * 5).toFixed(2)}deg`);
          this.style.setProperty('--ze-pan-x', `${(x * 8).toFixed(1)}px`);
          this.style.setProperty('--ze-pan-y', `${(y * 6).toFixed(1)}px`);
          this.style.setProperty('--ze-bottle-x', `${(x * 10).toFixed(1)}px`);
          this.style.setProperty('--ze-bottle-y', `${(y * 6).toFixed(1)}px`);
          this.style.setProperty('--ze-bottle-z', `${(Math.abs(x) * 18 + Math.abs(y) * 12).toFixed(1)}px`);
        }, {signal});
        this.stage.addEventListener('pointerleave', () => {
          this.style.setProperty('--ze-tilt-x', '0deg');
          this.style.setProperty('--ze-tilt-y', '0deg');
          this.style.setProperty('--ze-pan-x', '0px');
          this.style.setProperty('--ze-pan-y', '0px');
          this.style.setProperty('--ze-bottle-x', '0px');
          this.style.setProperty('--ze-bottle-y', '0px');
          this.style.setProperty('--ze-bottle-z', '0px');
        }, {signal});
        this.stage.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch') this.touchStart = {x: event.clientX, y: event.clientY};
        }, {signal});
        this.stage.addEventListener('pointerup', event => {
          if (event.pointerType !== 'touch' || !this.touchStart) return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.15) this.select(this.index + (dx < 0 ? 1 : -1), true);
        }, {signal});
      }
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, {signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) { this.running = false; this.style.setProperty('--ze-tilt-x', '0deg'); this.style.setProperty('--ze-tilt-y', '0deg'); } this.updatePlay(); this.schedule(); }, {signal});
      this.addEventListener('shopify:block:select', event => { const i = this.stories.indexOf(event.target.closest('[data-story]')); if (i >= 0) this.select(i, true); }, {signal});
      this.observer = new IntersectionObserver(entries => { const entry = entries[0]; this.visible = entry.isIntersecting; if (entry.isIntersecting) this.classList.add('is-inview'); this.schedule(); }, {threshold: .15});
      this.observer.observe(this);
      this.select(0);
      this.updatePlay();
      this.classList.add('is-ready');
    }
    select(index, manual = false) {
      const count = this.bottles.length;
      if (!count) return;
      this.index = (index + count) % count;
      this.bottles.forEach((bottle, i) => {
        let position = (i - this.index + count) % count;
        if (position > count / 2) position -= count;
        bottle.dataset.position = String(position);
        if (Math.abs(position) < 2) bottle.querySelector('img')?.setAttribute('loading', 'eager');
      });
      this.stories.forEach((story, i) => { story.hidden = i !== this.index; story.classList.toggle('is-active', i === this.index); });
      this.picks.forEach((pick, i) => { pick.classList.toggle('is-active', i === this.index); pick.setAttribute('aria-pressed', String(i === this.index)); });
      this.style.setProperty('--ze-accent', this.bottles[this.index].dataset.accent);
      this.style.setProperty('--ze-glow', this.bottles[this.index].dataset.glow);
      if (manual) {
        this.running = false;
        this.updatePlay();
        this.querySelector('[data-announcement]').textContent = this.stories[this.index].querySelector('h2').textContent;
      }
      this.schedule();
    }
    updatePlay() {
      this.classList.toggle('is-running', this.running);
      this.play.textContent = this.running ? 'Ⅱ' : '▷';
      this.play.setAttribute('aria-label', this.running ? this.play.dataset.pauseLabel : this.play.dataset.playLabel);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.running && this.visible && !this.hovered && !this.focused && !document.hidden) this.timer = setTimeout(() => this.select(this.index + 1), 6500);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.abort?.abort(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
